var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-box",style:({ height: _vm.height })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle-core"})])
}]

export { render, staticRenderFns }